module.exports = __webpack_public_path__ + "static/img/inconformity.a039df0.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/business/inconformity.png
// module id = 1595
// module chunks = 2